import * as React from 'react';
import { observer } from 'mobx-react';
import { configConsumer, ITranslationsCollection, translate } from 'elc-service';
import styled from 'styled-components';
import { ContentSpacing } from 'elc-base-theme';
import { Body2 } from 'elc-typography';
import { DateFormatter } from 'elc-formatters';
import { diContainer, serviceNames } from '../../../service-setup/diContainer';

export const preorderDatePlaceholderRegex = /::PREORDER_DATE::/gi;

import {
    PREORDER_NOT_AVAILABLE_MESSAGE,
    SHIPS_BY_MESSAGE
} from '../../constants/DataTestIdAttributes';
interface IPreorderBase {
    preorderDate: string;
}

export interface IPreoderMessageConfig {
    preorderDateFormat?: string;
}
export interface IPreorderMessage extends IPreorderBase {
    isPreorderActive: boolean;
    translations?: ITranslationsCollection;
    config?: IPreoderMessageConfig;
}

const StyledBlock = styled.div`
    margin: ${ContentSpacing.space24} 0;
`;

@configConsumer(['preorderDateFormat'])
@translate(['shipsBy', 'preorderNotAvailableMessage'])
@observer
export class PreorderMessage extends React.Component<IPreorderMessage> {
    private dateFormatter: DateFormatter;

    constructor(props: IPreorderMessage) {
        super(props);
        this.dateFormatter = diContainer.get(serviceNames.dateFormatter);
    }

    private buildMessageText = () => {
        const { preorderDate, isPreorderActive, translations, config } = this.props;
        const { preorderDateFormat } = config as IPreoderMessageConfig;
        const {
            preorderNotAvailableMessage = '',
            shipsBy = ''
        } = translations as ITranslationsCollection;

        const message = isPreorderActive ? shipsBy : preorderNotAvailableMessage;

        return this.dateFormatter.formatDateWithPlaceholder({
            message,
            date: preorderDate,
            dateFormat: preorderDateFormat,
            placeholderRegex: preorderDatePlaceholderRegex
        });
    };

    render() {
        const { isPreorderActive, preorderDate } = this.props;

        const message = preorderDate ? this.buildMessageText() : null;

        return message ? (
            <StyledBlock className={'elc-preorder-message-block'}>
                {isPreorderActive ? (
                    <Body2
                        className={'elc-preorder-ships-by-message'}
                        data-test-id={SHIPS_BY_MESSAGE}
                        dangerouslySetInnerHTML={{ __html: message }}
                    />
                ) : (
                    <Body2
                        className={'elc-preorder-not-available-message'}
                        data-test-id={PREORDER_NOT_AVAILABLE_MESSAGE}
                        dangerouslySetInnerHTML={{ __html: message }}
                    />
                )}
            </StyledBlock>
        ) : null;
    }
}
